import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './styles/dashboard.css';
import './styles/cats.css';
import './styles/requests.css';
import './styles/feeder.css';
import './styles/install.css';
import { registerSW } from 'virtual:pwa-register';
import { ensureManifestLink } from './utils/pwa';

// First ensure the manifest link exists to enable PWA features
ensureManifestLink();

// Register main PWA service worker with special logging
console.log('Registering service worker...');

const updateSW = registerSW({
  onNeedRefresh() {
    // Auto update immediately without prompt
    console.log('New service worker available, updating automatically...');
    updateSW(true);
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
  onRegistered(swRegistration) {
    console.log('Service worker registered!', swRegistration);
    
    // Check push subscription state
    if (swRegistration && 'pushManager' in swRegistration) {
      swRegistration.pushManager.getSubscription().then(subscription => {
        console.log('Current push subscription:', subscription);
      });
    }
  },
  onRegisterError(error) {
    console.error('Service worker registration error:', error);
  },
  immediate: true
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
); 